import { httpResource } from '@angular/common/http';
import { Component, computed, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { StationWeatherMeasurement, OpenSearchResponse, WeatherMeasurement } from '@models';
import { TrollCurrentComponent } from './current/current.component';
import { TrollChartComponent } from './chart/chart.component';
import { TrollCompassComponent } from './compass/compass.component';

@Component({
  selector: 'app-troll',
  templateUrl: './troll.component.html',
  styleUrls: ['./troll.component.scss'],
  imports: [
    RouterModule,
    TrollCurrentComponent,
    TrollCompassComponent,
    TrollChartComponent,
  ]
})
export class TrollComponent {
  // router binding (main.ts)
  location = input.required<'station' | 'airfield'>();

  url = computed(() => {
    return `https://app.npolar.no/opensearch/weather-troll-${this.location()}/_search`;
  });

  measurements = httpResource(() =>
    `${this.url()}?sort=measured:desc&q=measured:(>now-48h)&size=10000`, {
    parse: (response: unknown) => {
      return (response as OpenSearchResponse<StationWeatherMeasurement>).hits.hits.map(h => new WeatherMeasurement(h));
    }
  });

  latest = httpResource(() => `${this.url()}?sort=measured:desc&size=1`, {
    parse: (response: unknown) => {
      const hits = (response as OpenSearchResponse<StationWeatherMeasurement>).hits.hits;
      if (hits.length) {
        return new WeatherMeasurement(hits[0]);
      }

      return undefined;
    }
  });
}
